import { render, staticRenderFns } from "./caseQuestionComment.vue?vue&type=template&id=018d3665"
import script from "./caseQuestionComment.vue?vue&type=script&lang=js"
export * from "./caseQuestionComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports